var map = {
	"./feature-1.png": "f8aa",
	"./feature-2.png": "8332",
	"./feature-3.png": "d234",
	"./feature-4.png": "537d",
	"./feature-5.png": "c56b",
	"./feature-6.png": "5860",
	"./feature-7.png": "3b89",
	"./feature-8.png": "fa37",
	"./feature-news-1.jpg": "9cfa",
	"./feature-news-2.jpg": "9ad7",
	"./feature-news-3.jpg": "42c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6032";